import styled from 'styled-components';

export const PlanosContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .hint {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.muted};
  }
`;

export const Form = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 16px;
  flex-wrap: wrap;

  .field {
    display: flex;
    flex-direction: column;
    gap: 6px;

    label {
      font-size: 12px;
      font-weight: 500;
      color: ${({ theme }) => theme.colors.muted};
    }
  }

  .field.documento {
    min-width: 240px;
  }

  .field.plano {
    min-width: 160px;
  }
`;

export const Row = styled.tr`
  td {
    text-align: center;
  }
`;
